import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  pricingWrap: FelaCSS;
  enquiryWrap: FelaCSS;
  venuePricingWrapper: FelaCSS;
}

const styles: IStyles = {
  pricingWrap: {
    desktopDesign: {
      paddingTop: spacing[4],
    },

    maxWidthTabletSm: {
      paddingTop: spacing[4],
    },
  },

  enquiryWrap: {
    alignItems: 'center',
    paddingTop: spacing[8],

    maxWidthTabletSm: {
      paddingVertical: spacing[4],
    },
  },

  venuePricingWrapper: {
    flexDirection: 'column',
    gap: spacing[4],
  },
};

export default styles;
